import { GetAccountBindList, unbindShop } from "@/api/BuildAccount";
const state = {
    GetAccountBindList:{},
};

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  }
};

const actions = {
  GetAccountBindList({ commit },data) {
    return new Promise((resolve)=>{
      GetAccountBindList(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          // console.log(data.data, newData,'----------')
          commit("SET_DATA", {key:'GetAccountBindList',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve(res.data)
      });
    })
  },
  unbindShop({ commit },data) {
    return new Promise((resolve)=>{
      unbindShop(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'unbindShop',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve(res.data)
      });
    })
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
